<ng-template #container></ng-template>
<button
  class="addFieldButtonClass"
  mat-stroked-button
  color="accent"
  (click)="addField()"
>
  ADD ANOTHER FIELD
</button>
